import CampusHeader from '../../components/feature/CampusHeader';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedListings from './components/FeaturedListings';
import HowItWorks from './components/HowItWorks';
import SafetySection from './components/SafetySection';
import CampusStats from './components/CampusStats';
import Footer from '../../components/feature/Footer';
import SellNeatlyUsedSection from './components/SellNeatlyUsedSection';
import AgentCTASection from './components/AgentCTASection';
import TicketSalesSection from './components/TicketSalesSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <CampusHeader />
      <main>
        <HeroSection />
        {/* Trending Now: surfaced immediately after the hero */}
        <FeaturedListings />
        <CategorySection />
        {/* Added CTA sections in line with existing design */}
        <SellNeatlyUsedSection />
        <AgentCTASection />
        <TicketSalesSection />
        <HowItWorks />
        <SafetySection />
        <CampusStats />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;